import React, { useState, useEffect } from "react";
// import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";
import { getReports } from "../../../../actions/appointment";
import ColorList from "../../../../lib/ColorList";


// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function PaymentChatBar({ dates }) {

    const [payment, setPayment] = useState({
        colors: [],
        dates: [],
        payments: []
    })

    const getPaymnetReports = () => {
        getReports(`payment&from=${dates?.from}&to=${dates?.to}&dtype=${dates?.dateType}`)
            .then((res) => {
                if (res?.status) {
                    if (res?.data.length > 0) {
                        let colors = ColorList(res.data.length);
                        let keys = []
                        let values = []
                        res.data.forEach(item => {
                            keys.push(item._id);
                            values.push(item.totalFees)
                        })
                        setPayment({ colors: colors, dates: keys, payments: values })
                    }
                }
            })
            .catch(error => {
                console.log("error.......:)", error);
            });
    }

    useEffect(() => {
        getPaymnetReports();
    }, [dates])


    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: "Chart.js Line Chart",
            },
        },
    };

    // const labels = ["January", "February", "March", "April", "May", "June", "July"];


    const data = {
        labels: payment.dates,
        datasets: [
            {
                label: "payments",
                data: payment.payments, 
                borderColor: "rgb(255, 99, 132)",
                backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
        ],
    };

    return <Line options={options} data={data} />;
}
export default PaymentChatBar;
